import { PagamentoContainer } from "./style";
import Scaffold from "components/scaffold";
import InsideMenu from "components/insidemenu";
import InsideMenuButton from "components/insidemenu/components/inside_menu_button";

const PagamentoPage: React.FC = () => {
  return (
    <Scaffold>
      <PagamentoContainer>
        <InsideMenu title={"Pagamento"} icon={"credit_card"}>
          <InsideMenuButton
            path={"/faturamento/fatura"}
            name={"Fatura"}
            icon={"universal_currency_alt"}
          />
          <InsideMenuButton
            path={"/faturamento/pagamento"}
            name={"Pagamento"}
            icon={"credit_card"}
          />
        </InsideMenu>
      </PagamentoContainer>
    </Scaffold>
  );
};

export default PagamentoPage;
